import { Memento } from '@/common/undo-redo/memento';
import { deepClone } from '@/_utils/deep-clone';
import { getObjectDifferences } from '@/_utils/get-object-differences';
import { USE_UNDO_REDO_DIFF } from '@/common/undo-redo/new-undo-redo.service';

export class Originator<T = unknown> {
	private state: T;
	private currentDiff: Partial<T> = {};

	setState(state: T): void {
		this.currentDiff = deepClone(
			this.state && USE_UNDO_REDO_DIFF ? getObjectDifferences<T>(this.state, state) : state,
		);
		this.state = state;
	}

	saveToMemento(): Memento<T> {
		return new Memento<T>(deepClone(this.currentDiff ?? null));
	}

	getState(): T {
		return deepClone(this.state ?? null);
	}

	restore(memento: Memento<T>): void {
		Object.assign(this.state, deepClone(memento.getDiff()));
	}
}
